<script setup lang="ts">
import { formatDate } from "~/helpers/education";
import type { Image } from "~/types/common";

const props = defineProps<{
  slug: string;
  avatar: Image;
  fullName: string;
  publishedAt: string;
}>();
</script>

<template>
  <component
    :is="props.slug ? 'a' : 'div'"
    :href="props.slug ? `/education-authors/${props.slug}` : undefined"
    class="education-author d-flex align-items-center text-decoration-none text-body"
  >
    <img
      v-if="props.avatar"
      :src="$getStrapiImageSrc(props.avatar)"
      :alt="props.fullName"
      class="img-fluid object-fit-cover"
    />
    <div class="d-flex flex-column ms-10">
      <span class="fw-500 text-nowrap">{{ props.fullName }}</span>
      <span class="fz-14">{{ formatDate(props.publishedAt) }}</span>
    </div>
  </component>
</template>
